export default "__VITE_ASSET__IVazUQ2p__"